export default __webpack_public_path__ + "static/media/gallery_03.f2da17b0.jpg";